// Shared formatters used across admin sub-components.
export const fmt = (v) => Number(v ?? 0).toLocaleString();
export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" }) : "—";
